import { SATOSPortal } from "@/data-adapter/SATOSPortal";
import { EditableLiveTag } from "@/features/live/model/satos-live/EditableLiveTag";
import { LiveTag } from "@/features/live/model/satos-live/LiveTag";
import { LiveTagValue } from "@/features/live/model/satos-live/LiveTagValue";
import { LiveSettingsResponse } from "@/features/live/model/satos-live/settings/SettingsResponse";
import { useQuery } from "@tanstack/react-query";

import { ApplicationQueryKeys } from "@/service/ApplicationQueries";

export const useFetchLiveTags = () => {
	return useQuery<LiveTag[], any>({
		queryKey: [LiveQueryKeys.live, LiveQueryKeys.timeseries],
		queryFn: () => SATOSPortal.GetLiveTags(),
	});
};

export const useSearchLiveTags = (search: string) => {
	return useQuery<LiveTag[], any>({
		queryKey: [LiveQueryKeys.live, search],
		queryFn: () => SATOSPortal.SearchLiveTags(search),
		enabled: !!search,
	});
};

export const useFetchMultipleLiveTagsCurrentValue = (request: string[]) => {
	return useQuery<LiveTagValue[], any>({
		queryKey: [
			LiveQueryKeys.live,
			LiveQueryKeys.datapoints,
			LiveQueryKeys.multiple,
			request,
		],
		queryFn: () => SATOSPortal.GetMultipleLiveTagsCurrentValue(request),
		enabled: request.length > 0,
		refetchInterval: 3000,
	});
};

export const useFetchLiveSettings = () => {
	return useQuery<LiveSettingsResponse, any>({
		queryKey: [
			LiveQueryKeys.live,
			LiveQueryKeys.settings,
			ApplicationQueryKeys.user,
		],
		queryFn: () => SATOSPortal.GetLiveSettings(),
	});
};

export const useGetEditableLiveTag = (id: string | undefined) => {
	return useQuery<EditableLiveTag>({
		queryKey: [LiveQueryKeys.live, LiveQueryKeys.demoData, id],
		queryFn: () => SATOSPortal.GetEditableLiveTag(id!),
		enabled: !!id,
	});
};

export class LiveQueryKeys {
	static readonly live = "live";
	static readonly timeseries = "Timeseries";
	static readonly settings = "settings";
	static readonly saveTagValue = "saveTagValue";
	static readonly datapoints = "datapoints";
	static readonly multiple = "multiple";
	static readonly demoData = "demoData";
}
